module.exports = __webpack_public_path__ + "static/media/planet-level12.c21ff495.png";